import HttpRequest from './axios'

const baseUrl = process.env.NEXT_PUBLIC_BASE_URL
const timeout = 500000
const axios = new HttpRequest(baseUrl, timeout)

export default axios
